module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAoAAAARwAQMAAABAQXdDAAAABlBMVEUAAACAlxqHMEfoAAAAAXRSTlMAQObYZgAAAN9JREFUeAHtzDEBAAAIAyDtH1or7NsDAZgqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANgTCoVCoVAoFAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgUCoVCoVAoFAqFQqFQKBQKhUKhUCgUClMPFUQeH8ExnYsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/flyer_image_overlay_green_card_13.png
// module id = 1565
// module chunks = 1